(function($) {
    $('.account-section__title').click(function(e) {
        e.preventDefault();
        $('.account-section').removeClass('account-section--open');
        $(this).closest('.account-section').addClass('account-section--open');
    });

    $('.account-section__form--submits-on-radio-change input[type=radio]').change(function() {
        $(this).closest('form').submit();
    });

    $('.account-section__form--ajax').submit(function(e) {
        var button = document.activeElement;
        if (button.tagName === 'BUTTON' && button.classList.contains('js-account-no-ajax')) {
            return;
        }

        e.preventDefault();
        $.ajax({
            type: "POST",
            url: $(this).attr('action'),
            data: $(this).serialize(),
            success: function() {
                console.log('updated');
            }
        });
    });

    $('.account-section__show-all').click(function(e) {
        e.preventDefault();
        var section = $(this).closest('.account-section');

        var span = $(this).find('span');
        var altText = $(this).data('alt-text');
        $(this).data('alt-text', span.html());
        span.html(altText);

        if (section.hasClass('account-section--show-all')) {
            section.removeClass('account-section--show-all');
            $('html, body').stop().animate({
                'scrollTop': section.find('.account-section__snap-tag').offset().top
            }, 500, 'swing');
            accountSidebar.updateSidebar();
        } else {
            section.addClass('account-section--show-all');
        }
    });
})(jQuery);


(function mobileNavigation() {
    var mobileNav = document.querySelector('.js-account-nav-mobile');
    var current = mobileNav.querySelector('.account-nav__nav-item--active').cloneNode(true);
    var nav = mobileNav.querySelector('.account-nav__nav');
    var openIcon = document.createElement('div');
    openIcon.innerHTML = '<svg class="icon icon-less" role="img"><use xlink:href="' + AndrewMartin.svgSymbolsFile + '#icon-less"></use></svg>';
    var closedIcon = document.createElement('div');
    closedIcon.innerHTML = '<svg class="icon icon-more" role="img"><use xlink:href="' + AndrewMartin.svgSymbolsFile + '#icon-more"></use></svg>';

    current.classList.add('account-nav__nav-item--selected');
    current.appendChild(closedIcon.firstChild);
    current.appendChild(openIcon.firstChild);
    mobileNav.insertBefore(current, nav);

    current.addEventListener('click', function (event) {
        event.preventDefault();

        var isExpanded = mobileNav.getAttribute('aria-expanded') === 'true';
        mobileNav.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
    });
})();

var accountSidebar = {
    sidebar: $('.account-wrap__sidebar'),
    nav: $('.account-nav__nav--smooth-scroll'),
    navPlaceholder: $('.account-nav__placeholder'),
    init: function() {
        accountSidebar.navPlaceholder.height(accountSidebar.nav.height());
        accountSidebar.navPlaceholder.width(accountSidebar.nav.width());
        accountSidebar.setListeners();
        accountSidebar.updateSidebar();
    },
    setListeners: function() {
        accountSidebar.nav.find('.account-nav__nav-item').click(function(e) {
            e.preventDefault();
            $(document).off("scroll");

            $('.account-nav__nav-item').removeClass('account-nav__nav-item--active');
            $(this).addClass('account-nav__nav-item--active');

            var target = this.hash;
            $target = $(target);
            $('html, body').stop().animate({
                'scrollTop': $target.offset().top
            }, 500, 'swing', function () {
                window.location.hash = target;
                $(document).on("scroll", accountSidebar.updateSidebar);
                console.log('her');
                accountSidebar.updateSidebar();
            });
        });

        $(document).on("scroll", accountSidebar.updateSidebar);
    },
    updateSidebar: function() {
        var scrollPosition = $(document).scrollTop();
        $('.account-nav__nav-item').each(function () {
            var currentLink = $(this);
            var refElement = $(this.hash);
            if (refElement.length > 0) {
                var section = refElement.closest('.account-section');
                var adjustedTop = section.position().top + refElement.position().top - 5;
                var adjustedHeight = section.outerHeight() + parseInt(section.css('marginBottom'));

                if (adjustedTop < scrollPosition && (adjustedTop + adjustedHeight) > scrollPosition) {
                    currentLink.addClass('account-nav__nav-item--active');
                } else {
                    currentLink.removeClass('account-nav__nav-item--active');
                }
            }
        });

        var navPlaceholderBottom = accountSidebar.navPlaceholder.height() + accountSidebar.navPlaceholder.position().top;
        var sideBarBottom = accountSidebar.sidebar.height() + accountSidebar.sidebar.position().top;

        if (navPlaceholderBottom > sideBarBottom) {
            $('.account-nav[data-nav-attach-to-bottom]').addClass('account-nav--attached-to-bottom');
        } else {
            $('.account-nav[data-nav-attach-to-bottom]').removeClass('account-nav--attached-to-bottom');
        }
    }
};

accountSidebar.init();
